import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/SolRepublic/Hero";
import IndustriesContent from "../components/SolRepublic/IndustriesContent";
import PageTitle from "../components/SolRepublic/PageTitle";

import '../assets/Webdevelopment.css';



const SailaxDBC = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  </div>
	)
}

export default SailaxDBC;
